import { RootState } from '../../types.ts';

export const selectPriorSales = (state: RootState) => state.priorSales;
